module.exports = __webpack_public_path__ + "img/event-atelier-mensuel-pratique.4601c55.jpg";